import { Card, CardContent, CardMedia } from "@mui/material";
import "./LandingPageVideo.css";
import {Link, NavLink} from "react-router-dom"

export const calcDaysandTime = (releaseDate) => {
  const diff = Math.abs(
    new Date(releaseDate).getTime() - new Date().getTime()
  );
  const daysBtw = 1000 * 3600 * 24;
  var days = Math.floor(diff / daysBtw);
  var months = Math.floor(days / 31);
  var years = Math.floor(months / 12);

  if(years!==0)
      return `${years} years ago`;
  else if(months!==0)
      return `${months} months ago`
  else
      return `${days} days ago`
  // console.log(days, months, years);
};

 const LandingPageVideo = ({ video }) => {

  return (
    
    <Card
      sx={{ backgroundColor: "#181818", border: "none", boxShadow: "none" }}
      square={true}
      >
      <CardMedia>
        <img src={video.previewImage} alt={video.title}></img>
      </CardMedia>
      <CardContent sx={{ padding: "0px" }}>
        <div style={{ textAlign: "left", marginLeft: "0.2rem" }}>
        <a href={`/videos/${video._id}`} >{video.title}</a>
          <p>{calcDaysandTime(video.releaseDate)}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default LandingPageVideo;
